module.exports = {"title":"Docker - getting started","author":"jimmy yang","tags":["docker"],"series":"docker","date":"2016-01-01T00:00:00.000Z","draft":true,"body":"<p>Overview: 1</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./2016/docker/docker-getting-started.md
// module id = 719
// module chunks = 0